import React from 'react';
import { Checkbox, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import Flex from '../../../shared/components/basic/Flex';
import Text from '../../../shared/components/basic/Text';
import { formatearDatosGraduacion } from '../../../../helpers/modules/pel.helper';
import {transponer} from "../../../../helpers/modules/graduaciones.helper";
import { CERCA, INTERMEDIO, LEJOS } from '../../constants/graduacion';

export default function GraduacionCheckboxs({
  labels,
  graduacion,
  ordenGraduacion,
  onOjoCheckboxChange,
  permisos,
  vision,
}) {
  const { derecho, izquierdo } = graduacion;
  let esferaD = null;
  let ejeD = null;
  let cilindroD = null;
  let adicionD = derecho.ADD;
  let esferaI = null;
  let ejeI = null;
  let cilindroI = null;
  let adicionI = izquierdo.ADD;
  let izquierdoLabel = '';
  let derechoLabel = '';
  let labelOriginalDerecho = '';
  let labelOriginalIzquierdo = '';
  let mostrarGraduacionDerecha = false;
  let mostrarGraduacionIzquierda = false;
  if (vision === CERCA) {
    esferaD = derecho.ESFC;
    esferaI = izquierdo.ESFC;
    cilindroD = derecho.CILC;
    cilindroI = izquierdo.CILC;
    ejeD = derecho.AXISC;
    ejeI = izquierdo.AXISC;
  } else if(vision === LEJOS){
    esferaD = derecho.ESFL;
    esferaI = izquierdo.ESFL;
    cilindroD = derecho.CILL;
    cilindroI = izquierdo.CILL;
    ejeD = derecho.AXISL;
    ejeI = izquierdo.AXISL;
  } else if(vision === INTERMEDIO){
    esferaD = derecho.ESFI;
    esferaI = izquierdo.ESFI;
    cilindroD = derecho.CILL;
    cilindroI = izquierdo.CILL;
    ejeD = derecho.AXISL;
    ejeI = izquierdo.AXISL;
  }
  if (esferaD || cilindroD || ejeD) {
    mostrarGraduacionDerecha = true;
  }
  if (esferaI || cilindroI || ejeI) {
    mostrarGraduacionIzquierda = true;
  }
  esferaD = esferaD ? `Esf ${esferaD}` : '';
  cilindroD = cilindroD ? `Cil ${cilindroD}` : '';
  ejeD = ejeD ? `Eje ${ejeD}` : '';
  adicionD = adicionD ? `A ${adicionD}` : '';
  esferaI = esferaI ? `Esf ${esferaI}` : '';
  cilindroI = cilindroI ? `Cil ${cilindroI}` : '';
  ejeI = ejeI ? `Eje ${ejeI}` : '';
  adicionI = adicionI ? `A ${adicionI}` : '';
  const orderGrad = ordenGraduacion ? ordenGraduacion.split(';') : null;
  if (orderGrad && orderGrad[0] === 'EsfL') {
    derechoLabel = mostrarGraduacionDerecha ? `${esferaD}, ${cilindroD}, ${ejeD}, ${adicionD}` : 'Sin graduación';
    izquierdoLabel = mostrarGraduacionIzquierda ? `${esferaI}, ${cilindroI}, ${ejeI}, ${adicionI}` : 'Sin graduación';
  } else{
    derechoLabel = mostrarGraduacionDerecha ? `${ejeD}, ${cilindroD}, ${esferaD}, ${adicionD}` : 'Sin graduación';
    izquierdoLabel = mostrarGraduacionIzquierda ? `${ejeI}, ${cilindroI}, ${esferaI}, ${adicionI}` : 'Sin graduación';
  }
  labelOriginalIzquierdo = izquierdo.label_original;
  labelOriginalDerecho = derecho.label_original;

  const drawGraduacion = (graduacion, textComponent, usarCheckBox, ojo) => {
    const gradOjo = graduacion[ojo];
    const esGraduacionNegativa = (vision === CERCA && gradOjo.CILC < 0) || gradOjo.CILL < 0;
    const trabajaCilindroPositivo = permisos.configuracion.trabajar_cilindro_positivo !== 'N';
    let innerComponent = (
      <Text>
        {textComponent}
      </Text>
    );
    if (gradOjo.transposicion && trabajaCilindroPositivo) {
      innerComponent = (
        <Tooltip title={labelOriginalDerecho} overlayStyle={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
          <Text>
            {textComponent}
          </Text>
        </Tooltip>
      );
    } else if (!trabajaCilindroPositivo && esGraduacionNegativa) {
      innerComponent = (
        <Tooltip title={labelOriginalDerecho} overlayStyle={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
          <Text>
            {textComponent}
          </Text>
        </Tooltip>
      );
    }
    if (usarCheckBox) {
      return (
        <Checkbox
          style={{ marginLeft: 8 }}
          onChange={() => onOjoCheckboxChange({ derecho: ojo === 'derecho', izquierdo: ojo !== 'derecho' })}
          defaultChecked={gradOjo.isSelected}
        >
          {innerComponent}
        </Checkbox>
      );
    }
    return innerComponent;
  };
  return (
    <Flex>
      {drawGraduacion(graduacion, `Dcho: ${derechoLabel}`, mostrarGraduacionDerecha, 'derecho')}
      {drawGraduacion(graduacion, `Izdo: ${izquierdoLabel}`, mostrarGraduacionIzquierda, 'izquierdo')}
    </Flex>
  );
}

GraduacionCheckboxs.propTypes = {
  graduacion: PropTypes.shape({
    derecho: PropTypes.shape({
      ESFC: PropTypes.string,
      ESFL: PropTypes.string,
      AXISC: PropTypes.string,
      AXISL: PropTypes.string,
      ADD: PropTypes.string,
      CILL: PropTypes.string,
      CILC: PropTypes.string,
      isSelected: PropTypes.bool,
      label: PropTypes.string,
      visible: PropTypes.bool,
    }).isRequired,
    izquierdo: PropTypes.shape({
      ESFC: PropTypes.string,
      ESFL: PropTypes.string,
      AXISC: PropTypes.string,
      AXISL: PropTypes.string,
      ADD: PropTypes.string,
      CILL: PropTypes.string,
      CILC: PropTypes.string,
      isSelected: PropTypes.bool,
      label: PropTypes.string,
      visible: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  labels: PropTypes.shape({
    derechoLabel: PropTypes.string,
    izquierdoLabel: PropTypes.string,
  }).isRequired,
  onOjoCheckboxChange: PropTypes.func,
  vision: PropTypes.string.isRequired,
  ordenGraduacion: PropTypes.string,
};
GraduacionCheckboxs.defaultProps = {
  onOjoCheckboxChange: () => {},
  ordenGraduacion: null,
};
